<template>
  <Dialog ref="dialog" type="reward" :show="$bus.rewardDialog.show" :title="$bus.transify['FLIP_CONGRATULATIONS']">
    <template v-slot:dialog-content v-if="$bus.rewardDialog.show">
      <Item class="item" :type="Item.type === 1 ? 'light' : 'normal'" :nums="Item.num" :imgSrc="Item.src" :name="Item.name"></Item>
      <ff-button type="confirm" @btnEvent="$refs.dialog.close()">
        <span class="confirm-btn-text">{{$bus.transify['FLIP_CONFIRM']}}</span>
      </ff-button>
      <p class="confirm-tips">{{ unique ? $bus.transify['UNIQUE_REDEEM_ALREADY_HAVE'] : $bus.transify['COMMON_TIPS_ITEM'] }}</p>
    </template>
  </Dialog>
</template>

<script>
import Item from '@/components/common/Item.vue'
import ffButton from '@/components/common/Button.vue'
import Dialog from '@/components/common/Dialog.vue'
export default {
  components: {
    Item,
    ffButton,
    Dialog
  },
  data () {
    return {
      unique: false
    }
  },
  computed: {
    Item () {
      let result = this.$bus.rewardDialog.data || {}
      let rewardPool = this.$bus.rewardPool
      if ((Object.keys(result)).length !== 0) {
        let item = rewardPool.filter(item => item.type === result.pool)[0]
        this.setUnique(result.is_token)
        this.setRewardStatus(result.pool)
        return item
      } else {
        return {
          nums: 0,
          src: '',
          name: ''
        }
      }
    }
  },
  methods: {
    setUnique (isToken) {
      if (isToken === 0) {
        this.unique = false
      } else {
        this.unique = true
      }
    },
    setRewardStatus (pool) {
      this.$bus.rewardPool.forEach((item, index) => {
        if (pool === item.type) {
          this.$bus.rewardPool[index].status = 1
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  @include px2res(margin, 0, 20);
  .item-nums {
    color: #FFDE00;
    font-weight: 500;
    position: absolute;
    z-index: 3;
    @include px2res(top, 12);
    @include px2res(right, 22);
    @include px2res(font-size, 30);
  }
}
.item.light {
  animation: none !important;
  box-shadow: none !important;
}
.confirm-btn-text {
  flex: auto;
  color: #000;
  @include px2res(height, 60);
  @include px2res(line-height, 66);
}
.confirm-tips {
  color: #FFDBA7;
  text-align: center;
  @include px2res(font-size, 26);
  @include px2res(margin-top, 8);
  text-transform: uppercase;
  font-style: italic;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/reward/index.vue